<script>
import router from '@/router';
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import { authFackMethods } from '@/state/helpers';
import { required } from 'vuelidate/lib/validators';
import Swal from 'sweetalert2';
import axios from 'axios';
export default {
	page: {
		title: 'Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	components: { Header, Footer },
	data() {
		return {
			title: '',
			updateForm: {
				profileField: null,
				updateValue: null,
				comment: null,
			},
			profileFields: [
				{ id: 'First Name', name: 'First Name' },
				{ id: 'Middle Name', name: 'Middle Name' },
				{ id: 'Last Name', name: 'Last Name' },
				{ id: 'Email', name: 'Email' },
				{ id: 'Address (Line 1)', name: 'Address (Line 1)' },
				{ id: 'Address (Line 2)', name: 'Address (Line 2)' },
				{ id: 'Address (City)', name: 'Address (City)' },
				{ id: 'Address (State)', name: 'Address (State)' },
				{ id: 'Address (Zip Code)', name: 'Address (Zip Code)' },
				{ id: 'Phone', name: 'Phone' },
				{ id: 'Phone (Alternate)', name: 'Phone (Alternate)' },
			],
			isUpdating: false,
			userId: null,
			userData: JSON.parse(localStorage.getItem('web_user')),
		};
	},
	validations: {
		updateForm: {
			profileField: { required },
			updateValue: { required },
		},
	},
	mounted() {
		this.userId = this.userData.id;
	},
	methods: {
		...authFackMethods,
		maybeGotoRoute(routeName) {
			const component = this;
			if (!routeName) {
				return;
			}
			if (component.$route.name == routeName) {
				return;
			}
			router.push({ name: routeName });
		},
		loginPage() {
			const component = this;
			component.maybeGotoRoute('login');
		},
		async updateProfileField() {
			let component = this;
			try {
				component.isUpdating = true;
				component.$v.$touch();

				if (component.$v.$invalid) {
					component.isUpdating = false;
					return;
				}

				if (!Object.hasOwn(component.userData, 'token') || component.userData.token == null) {
					component.isUpdating = false;
					throw new Error('Invalid login');
				}

				let config = {
					headers: {
						Authorization: 'Bearer ' + component.userData.token,
						Accept: 'application/json',
					},
				};

				let requestBody = {};
				requestBody.profile_field = component.updateForm.profileField ? component.updateForm.profileField : '';
				requestBody.update_value = component.updateForm.updateValue ? component.updateForm.updateValue : '';
				requestBody.comment = component.updateForm.comment ? component.updateForm.comment : '';

				const response = await axios.post('user/request-profile-update', requestBody, config);
				if (response.status != 200) {
					component.isUpdating = false;
					throw new Error('Invalid response from server');
				}

				Swal.fire({
					title: 'Success!',
					text: 'Request submitted!',
					icon: 'success',
					width: 350,
					showConfirmButton: false,
					timer: 1500,
				});

				component.maybeGotoRoute('profile');
				component.isUpdating = true;
			} catch (error) {
				component.isUpdating = false;
				Swal.fire({
					title: 'Error!',
					text: error.message || 'Something Went Wrong :(',
					icon: 'error',
					width: 350,
					showConfirmButton: true,
				});
				console.log(error);
			}
		},
	},
};
</script>

<template>
	<div>
		<Header></Header>
		<div id="main-title" class="secondary">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-6 align-self-center">
						<h3 class="title">Request profile information update</h3>
					</div>
					<div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
						<p class="need-help">Need Help ? <a href="javascript:">Contact Us</a></p>
					</div>
				</div>
			</div>
		</div>
		<!-- main content -->
		<div class="py-5 mb-0 container custom-form">
			<div class="card py-5 mb-0 container" v-if="userId">
				<div class="card-body">
					<div class="row my-3">
						<div class="col-12">
							<label>Profile Field</label>
							<b-form-select class="form-select" :options="profileFields" value-field="id" text-field="name" v-model="updateForm.profileField" :class="{ 'is-invalid': isUpdating && $v.updateForm.profileField.$error }">
								<option slot="first" :value="null" disabled>Select Field</option>
							</b-form-select>
							<div v-if="isUpdating && $v.updateForm.profileField.$error" class="invalid-feedback">
								<span v-if="!$v.updateForm.profileField.required">This field is required.</span>
							</div>
						</div>
					</div>

					<div class="row my-3 pt-3">
						<div class="col-12">
							<label>Update Value</label>
							<input v-model="updateForm.updateValue" type="text" placeholder="Write correction or update here..." class="mt-2 form-control" :class="{ 'is-invalid': isUpdating && $v.updateForm.updateValue.$error }" />
							<div v-if="isUpdating && $v.updateForm.updateValue.$error" class="invalid-feedback">
								<span v-if="!$v.updateForm.updateValue.required">This field is required.</span>
							</div>
						</div>
					</div>

					<div class="row my-3 pt-3">
						<div class="col-12">
							<label>Additional Comment</label>
							<div>
								<textarea v-model="updateForm.comment" class="form-control" rows="10" placeholder="Any other additional information you might like to provide..."></textarea>
							</div>
						</div>
					</div>

					<div class="row my-3 pt-3">
						<div class="col-12">
							<b-button class="btn-custom mt-0" variant="custom" @click="updateProfileField" :disabled="isUpdating"> Submit </b-button>
						</div>
					</div>
				</div>
			</div>

			<div class="card py-5 mb-0 container" v-else>
				<div class="card-body">
					<div class="row">
						<div class="col-12">
							<div class="text-center">
								<b-button class="btn-custom mt-0" variant="custom" @click.prevent="loginPage"> Login </b-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<Footer></Footer>
	</div>
</template>
<style scoped></style>
